import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MessnegerService } from 'src/app/services/messenger.service';

@Component({
  selector: 'app-useful-links',
  templateUrl: './useful_links.component.html',
  styleUrls: ['./useful_links.component.scss']
})
export class UsefulLinksComponent implements OnInit {
  router = inject(Router);
  messenger = inject(MessnegerService)
  @Input() data: any;
  searchTerm: string = "";
  ngOnInit(): void {
  }

  search() {
    const queryParams = { q: this.searchTerm };
    this.router.navigate(['/search'], { queryParams: queryParams });
  }
  ngAfterViewInit() {
    this.messenger.changeMessage('last-loaded');
  }
}

